/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PrepareSparkPaymentRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {PrepareSparkPaymentResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const prepareSparkPayment = (request: PrepareSparkPaymentRequest, options?: CashRequestOptions) => post<PrepareSparkPaymentRequest, PrepareSparkPaymentResponse>("/2.0/cash/prepare-spark-payment", request, {...options, rejectOnError: true })